// extracted by mini-css-extract-plugin
export default {"menuBlock":"_E-z","title":"aF-z","nav":"bF-z","flexCell":"cF-z","facetLink":"dF-z"};